<template>
	<div class="mobile mobileClassTab">
				<div class="mobile-study">
					<van-list v-if="examTotal > 0">
						<van-cell class="list" v-for="item in examLists" :key="item.id">
							<div style="margin-left: 0.426667rem; display: flex; margin-top: 0.426667rem">
								<div>
									<img class="cover" :src="item.courseLogoUrl" alt />
								</div>
								<div>
									<div class="mobile-study-title">
										{{ item.examName }}
									</div>
									<div class="textImage_he">
										<div class="period">考试时间:{{ item.startTime | formatDate }}-{{ item.endTime | formatDate }}</div>
										<div class="period">考试限时:{{ item.examDuration }}分钟</div>
									</div>
								</div>
							</div>
							<div>
								<div class="mobile-study-btn">
									<div class="examinationResults">
										考试成绩: <span>{{ questionTotals.score }}</span>
									</div>
									<div @click="mobileExamAnalysis(item.lastExamRecordId)" class="viewResolution">查看解析</div>
									<van-button
										v-if="item.userExamStatus == '0'"
										round
										size="small"
										type="danger"
										:to="{
											path: '/mobileExam',
											query: {
												id: item.examId,
											},
										}"
										>开始考试</van-button
									>
									<van-button
										v-if="item.userExamStatus == '1'"
										round
										size="small"
										type="danger"
										:to="{
											path: '/mobileExam',
											query: {
												id: item.examId,
											},
										}"
										>继续考试</van-button
									>
									<van-button
										v-if="item.userExamStatus == '2'"
										round
										size="small"
										type="danger"
										:to="{
											path: '/mobileExam',
											query: {
												id: item.examId,
											},
										}"
										>重新考试</van-button
									>
								</div>
							</div>
						</van-cell>
					</van-list>
					<van-list class="custom-class-image" v-else>
						<van-empty class="custom-image" image="../../../static/images/mobile/examNum.png" description="暂无考试" />
					</van-list></div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
export default {
	data() {
		return {
			active: 2,
			actives: 0,
			examLists: [],
			pageNumber: 1,
			pageSize: 5,
			loading: false,
			finished: false,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			examTotal: "",
			courseTotal: "",
			questionTypeSummaries: [],
			type: "001001",
			types: "001001",
			realName: "",
			userHeadImagUrl: "",
			rightCountAll: 0, //正确值
			questionTotals: {
				score: 0,
			},
			lastExamRecordId: [],
			lastExams: "",
			beginTime: "",
			endTime: "",
            packageId:this.$route.query.id
		};
	},
	methods: {
    // 考试列表
		examList() {
			let params = {};
			params.userId = this.$sessionStore.getUserId();
			params.goodsId = '';
			params.curPage = this.pageNumber;
			params.pageSize = this.pageSize;
			this.$axiosPackag.getMessageByAxios("GET", "/api/student/onlineExam/listOnlineExamH5", params, null, null, (resD) => {
				if (resD.rows) {
					let array = [];
					let arraylastExam = "";
					resD.rows.forEach(function (item) {
						let columnItem = {};
						let lastExam = {};
						columnItem.id = item.id;
						columnItem.examName = item.examName;
						columnItem.courseName = item.courseName;
						columnItem.lastExamRecordId = item.lastExamRecordId;
						columnItem.courseLogoUrl = item.courseLogoUrl;
						columnItem.examId = item.examId;
						columnItem.examDuration = item.examDuration;
						columnItem.startTime = item.startTime;
						columnItem.endTime = item.endTime;
						columnItem.userExamStatus = item.userExamStatus;
						lastExam = item.lastExamRecordId;
						array.push(columnItem);
						arraylastExam = arraylastExam + lastExam;
					});
					this.examLists = this.examLists.concat(array);
					this.lastExamRecordId = arraylastExam;
				} else { 
					this.$message.error(resD.message);
				}
				this.examTotal = resD.total;
				this.examScoreData();
			});
		},
		examScoreData() {
			let params = {};
			params.recordId = this.lastExamRecordId;
			this.$axiosPackag.getMessageByAxios(
				"POST",
				"/api/student/onlineExam/viewRecord",
				params,
				null,
				null,
				(res) => {
					this.questionTypeSummaries = res.questionTypeSummaries;
					//初始化数据
					this.questionTotals = {
						score: 0,
					};
					//答题汇总 对，错，未答，总分
					for (var i = 0; i < this.questionTypeSummaries.length; i++) {
						for (var j = 0; j < this.questionTypeSummaries[i].questions.length; j++) {
							if (parseFloat(this.questionTypeSummaries[i].questions[j].userScore) > 0) {
								this.questionTotals.score += parseFloat(this.questionTypeSummaries[i].questions[j].userScore);
							}
						}
					}
				},
				(err) => {
					// Toast("没有考试记录");
				},
				false
			);
		},
		cannelGoBack() {
			this.$router.go(-1);
		},
		//考试解析
		mobileExamAnalysis(id) {
			this.$router.push({ path: "/mobileExamAnalysis", query: { id: id } });
		},
	},
	components: {},
	mounted() {
		// this.examScoreData();
	},
	created() {
		this.examList();
	},
	//时间戳转换
	filters: {
		formatDate: function (value) {
			let date = new Date(value);
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? "0" + MM : MM;
			let d = date.getDate();
			d = d < 10 ? "0" + d : d;
			return  MM + "月" + d + "日";
		},
	},
};
</script>


<style>
.mobileClassTab .van-tabs__wrap {
	width: 5.12rem !important;
}
.mobileClassTab .van-tabs__line {
	height: 0.026667rem;
}
.mobileClassTab .van-tab--active {
	font-size: 0.426667rem;
	font-weight: bold;
	color: #000000;
}
</style>
<style scoped>
.van-tab--active {
	font-size: 0.426667rem;
	font-weight: bold;
	color: #000000;
}
.cover {
	width: 2.826667rem;
	height: 1.6rem;
}
.mobile-study .list {
	box-shadow: 0rem 0.16rem 0.533333rem rgba(216, 216, 216, 0.49);
	border-radius: 0.106667rem;
}
.van-list:last-child {
	padding-bottom: 3rem;
}
.mobile-study .mobile-study-title {
	margin-left: 0.266667rem;
	font-weight: bold;
	font-size: 0.426667rem;
	margin-bottom: 0.133333rem;
}
.textImage_he {
	margin-left: 0.266667rem;
}
.textImage_he .period {
	margin-bottom: 0.133333rem;
}
.mobile-study-btn-class {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-top: 0.426667rem;
	margin-bottom: 0.426667rem;
	margin-left: 1.093333rem;
}
.mobile-study-btn-class .van-button {
	width: 2.346667rem;
	height: 0.746667rem;
}
.mobile-study-btn {
	border-top: 2px solid #dfdede;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-top: 0.426667rem;
	margin-bottom: 0.426667rem;
	margin-right: 0.426667rem;
	margin-left: 0.426667rem;
	padding-top: 0.426667rem;
}

.mobile-study-btn .examinationResults span {
	color: #dc0021;
	font-weight: 400;
	font-size: 0.426667rem;
}
.mobile-study-btn .viewResolution {
	margin-left: -1rem;
	color: #2e56d5;
	font-weight: 400;
	font-size: 0.293333rem;
}
.mobile-study-btn .van-button {
	width: 2.346667rem;
	height: 0.853333rem;
}

.progress {
	margin-left: 0.426667rem;
}
.progress span {
	font-size: 0.32rem;
	margin-left: 0.106667rem;
}
.custom-image {
	margin: 0 auto;
	width: 6.026667rem;
	height: 3.146667rem;
}
.custom-class-image {
	margin-top: 3.093333rem;
}
</style>


// WEBPACK FOOTER //
// MobileExamList.vue?6975fd80